
import * as PropTypes from 'prop-types';

import { Avatar } from "@progress/kendo-react-layout";
import { useLocalization } from '@progress/kendo-react-intl';
import { useEffect, useState } from 'react';
import { userIcon } from '@progress/kendo-svg-icons';
import { SvgIcon } from "@progress/kendo-react-common";
import { Link } from 'react-router-dom';
import { getSharedMqttClient } from '../config/mqttClient';

export const Header = (props:any) => {
    const { onButtonClick } = props;
    const localizationService = useLocalization();

    const [user, setUser] = useState('');
    const [mqttOnline, setMqttOnline] = useState(false);

    useEffect(() => {
        const loggedInUser = localStorage.getItem("user");
        const username = localStorage.getItem("username");
        if (loggedInUser) {
          setUser(loggedInUser);
        }
        if (username) {
          setUser(username);
        }
      }, []);

    useEffect(() => {
        let currentClient: any = null;
        let monitorId: number | null = null;

        const handleConnect = () => {
            setMqttOnline(true);
        };

        const handleDisconnect = () => {
            setMqttOnline(false);
        };

        const unbindCurrentClient = () => {
            if (!currentClient) {
                return;
            }

            currentClient.off('connect', handleConnect);
            currentClient.off('close', handleDisconnect);
            currentClient.off('offline', handleDisconnect);
            currentClient.off('end', handleDisconnect);
            currentClient.off('reconnect', handleDisconnect);
            currentClient.off('error', handleDisconnect);
        };

        const bindClient = (nextClient: any) => {
            if (currentClient === nextClient) {
                return;
            }

            unbindCurrentClient();
            currentClient = nextClient;

            if (!currentClient) {
                setMqttOnline(false);
                return;
            }

            setMqttOnline(Boolean(currentClient.connected));
            currentClient.on('connect', handleConnect);
            currentClient.on('close', handleDisconnect);
            currentClient.on('offline', handleDisconnect);
            currentClient.on('end', handleDisconnect);
            currentClient.on('reconnect', handleDisconnect);
            currentClient.on('error', handleDisconnect);
        };

        const syncClient = () => {
            const client = getSharedMqttClient();
            bindClient(client);

            if (client) {
                setMqttOnline(Boolean(client.connected));
            }
        };

        syncClient();
        monitorId = window.setInterval(syncClient, 3000);

        return () => {
            if (monitorId !== null) {
                window.clearInterval(monitorId);
            }
            unbindCurrentClient();
        };
    }, []);

    return (
        <header className="header shell-header">
            <div className="nav-container shell-nav-container">
                <button
                    type="button"
                    className="menu-button shell-menu-button"
                    onClick={onButtonClick}
                    aria-label="Toggle navigation"
                >
                    <span className={'k-icon k-i-menu'} />
                </button>

                <div className="title">
                    <Link to="/home/dashboard">
                        <h1 style={{ margin: '0 auto' }} className={'h1'} >{localizationService.toLanguageString('title','NOT_FOUND')}</h1>
                    </Link>
                </div>      

                <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'right' }}>
                    
                    <p className="shell-user-name" >{user}</p>

                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '4px' }}>
                        <span
                            style={{
                                width: '9px',
                                height: '9px',
                                borderRadius: '50%',
                                display: 'inline-block',
                                backgroundColor: mqttOnline ? '#25a244' : '#cf2f2f',
                                boxShadow: mqttOnline
                                    ? '0 0 0 2px rgba(37, 162, 68, 0.16)'
                                    : '0 0 0 2px rgba(207, 47, 47, 0.16)'
                            }}
                        />
                        <span 
                            style={{
                                marginLeft: '6px',
                                color: '#ffffff',
                                fontSize: '13px',
                            }}
                        >
                            {mqttOnline ? localizationService.toLanguageString('dashboard.mqtt_online','NOT_FOUND') : localizationService.toLanguageString('dashboard.mqtt_offline','NOT_FOUND')}
                        </span>
                    </div>
                </div>

            </div>
        </header>
    );
}

Header.displayName = 'Header';
Header.propTypes = {
    page: PropTypes.string,
    onButtonClick: PropTypes.func,
    changeTheme: PropTypes.func,
    theme: PropTypes.string,
};

